export class VueHeap {
  identify(userId: string | null) {
    window.heap.identify(userId);
  }
  resetIdentity() {
    window.heap.resetIdentity();
  }
  addUserProperties(options: any) {
    window.heap.addUserProperties(options);
  }
}

const loadHeapScript = function loadHeapScript(appId: string) {
  window.heap = window.heap || [];
  window.heap.load = function (e: any, t: any = {}) {
    window.heap.appid = e, window.heap.config = t;
    const r = t.forceSSL || 'https:' === document.location.protocol;
    const a = document.createElement('script');
    const n = document.head; // different from the docs!
    const p = [
      'addEventProperties',
      'addUserProperties',
      'clearEventProperties',
      'identify',
      'resetIdentity',
      'removeEventProperty',
      'setEventProperties',
      'track',
      'unsetEventProperty',
    ];
    a.type = 'text/javascript';
    a.async = !0, a.src = (r ? 'https:' : 'http:') + '//cdn.heapanalytics.com/js/heap-' + e + '.js';
    n.appendChild(a); // diffenent from the docs!
    for (let o = function (e: any) {
        return function () {
          window.heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }, c = 0; c < p.length; c += 1) window.heap[p[c]] = o(p[c]);
  };
  window.heap.load(appId);
};

const init = () => {
  return new VueHeap;
};

const vueHeap: any = [];
vueHeap.install = function install(vue: any, appId: string) {
  // tslint:disable variable-name
  const Vue = vue;
  const vueHeap = init();
  loadHeapScript(appId);
  Object.defineProperty(Vue.prototype, '$heap', {
    get: () => vueHeap,
  });
};

export default vueHeap;
